/* Dansk katalog for locale-bank-archive-filter-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'bank.archive.filter.postingType': 'Posteringstype',
  'bank.archive.filter.purchase': 'Køb',
  'bank.archive.filter.otherSale': 'Andet salg',
  'bank.archive.filter.payment': 'Betaling',
  'bank.archive.filter.manualPosting': 'Fri postering',
  'bank.archive.filter.bankPosting': 'Bankpostering',
  'bank.archive.filter.publicPayment': 'Løn og afgifter',
  'bank.archive.filter.ignored': 'Ignoreret banklinje',
  'bank.archive.filter.documentation': 'Dokumentation',
  'bank.archive.filter.missingAttachment': 'Mangler bilag',
  'bank.archive.filter.hasAttachment': 'Har bilag',
  'bank.archive.sort.label': 'Sortér posteringer',
  'bank.archive.sort.statementOrder': 'Rækkefølge i kontoudtoget',
  'bank.archive.sort.dateDesc': 'Dato: nyeste først',
  'bank.archive.sort.dateAsc': 'Dato: ældste først',
  'bank.archive.sort.amountDesc': 'Beløb: højeste først',
  'bank.archive.sort.amountAsc': 'Beløb: laveste først',
});
